import React, { useState, useEffect } from "react";
import CardButtonGroup from "../../components/plot_engagement/ActivityCard";

// Component
import WeedicidePopup from "./Popup/WeedicidePopup";
import IrrigationPopup from "./Popup/IrrigationPopup";
import CropProtectionPopup from "./Popup/CropProtectionPopup";
import LenoBagsPopup from "./Popup/LenoBagsPopup";
import FertilizerPopup from "./Popup/FertilizerPopup";
import PreparationIconWithTick from "./IconStatus";
import { useAlert } from "../../components/Alert";
import CropHealthPopup from "./Popup/CropHealthPopup";

const DayWiseActivity = ({ status, plantingStatus, updateStatus, t }) => {
  const [popupType, setPopupType] = useState(null);
  const { showAlert } = useAlert();

  const queryParams = new URLSearchParams(location.search);
  const openPopup = queryParams.get("openPopup");

  const setOpenPopupType = () => {
    if (openPopup) {
      setPopupType(openPopup);
    }
  };

  const handleButtonClick = (type) => {
    if (plantingStatus[0].planting) {
      setPopupType(type);
    } else {
      showAlert("warning", t("Complete Planting Activity first!"));
    }
  };

  useEffect(() => {
    setOpenPopupType();
  }, [openPopup]);

  const getActivityStatus = (activity) =>
    status && Array.isArray(status) && status[0]?.[activity];
  const DayWiseActivityButton = [
    {
      label: t("Weedicide application"),
      icon: (
        <PreparationIconWithTick
          status={getActivityStatus("weedicide")}
          activityType="weedicide"
        />
      ),
      onClick: () => handleButtonClick("Weedicide"),
    },
    {
      label: t("Fertilizer"),
      icon: (
        <PreparationIconWithTick
          status={getActivityStatus("fertilizer")}
          activityType="fertilizer"
        />
      ),
      onClick: () => handleButtonClick("Fertilizer"),
    },
    {
      label: t("Irrigation Schedule"),
      icon: (
        <PreparationIconWithTick
          status={getActivityStatus("irrigation_schedule")}
          activityType="irrigation_schedule"
        />
      ),
      onClick: () => handleButtonClick("Irrigation"),
    },
    {
      label: t("Crop Protection"),
      icon: (
        <PreparationIconWithTick
          status={getActivityStatus("crop_protection")}
          activityType="crop_protection"
        />
      ),
      onClick: () => handleButtonClick("CropProtection"),
    },
    {
      label: t("Leno Bags"),
      icon: (
        <PreparationIconWithTick
          status={getActivityStatus("leno_bags")}
          activityType="leno_bags"
        />
      ),
      onClick: () => handleButtonClick("LenoBags"),
    },
    {
      label: t("Book here to check crop health"),
      icon: (
        <PreparationIconWithTick
          status={getActivityStatus("book_to_check_crop_health")}
          activityType="book_to_check_crop_health"
        />
      ),
      onClick: () => handleButtonClick("CropHealth"),
    },
  ];

  const closePopup = () => {
    setPopupType(null);
    updateStatus();
  };
  return (
    <div>
      <CardButtonGroup buttons={DayWiseActivityButton} t={t} />
      {popupType === "Weedicide" && (
        <WeedicidePopup onClose={closePopup} t={t} />
      )}
      {popupType === "Irrigation" && (
        <IrrigationPopup onClose={closePopup} t={t} />
      )}
      {popupType === "CropProtection" && (
        <CropProtectionPopup onClose={closePopup} t={t} />
      )}
      {popupType === "LenoBags" && <LenoBagsPopup onClose={closePopup} t={t} />}
      {popupType === "Fertilizer" && (
        <FertilizerPopup onClose={closePopup} t={t} />
      )}
      {popupType === "CropHealth" && (
        <CropHealthPopup onClose={closePopup} t={t} />
      )}
    </div>
  );
};

export default DayWiseActivity;
